module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.941e7aeb.woff";